import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import * as Highcharts from 'highcharts/highstock';
import {MatTabsModule} from '@angular/material/tabs';
import { TranslateModule } from "@ngx-translate/core";
import { PollResultService } from "../../poll-result.service";
import { PollResult, PollResultValue } from "../../poll-result.type";
@Component({
    selector: "scale-question-result-pyramid-chart",
    templateUrl: "./scale-question-result-pyramid-chart.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        TranslateModule
    ]
})
export class ScalePollResultPyramidChartComponent implements AfterViewInit {

    @Input() results: PollResult;
    @Input() chartId: string
    @Input() context: string

    constructor(
        private pollResultService: PollResultService,
    ) {}

    ngAfterViewInit(){
        const chartData = this.pollResultService.formatScalePollResultForPyramidChart(this.results.values)
        Highcharts.chart('questionPyramidResult' + this.chartId, this.resultChartConfig(chartData, this.results.values[0]?.label, this.results.values[4]?.label) as any)
    }

    resultChartConfig (chartData, positive: string, negative: string) {
        return {
            chart: {
                type: 'bar',
                height: 250,
            },
            title: {
                text: ''
            },
            xAxis: [{
                    categories: [negative],
                    labels: {
                        useHTML:true,
                        style:{
                            fontSize: '11.5px',
                            width:'65px',
                            whiteSpace:'normal',//set to normal
                        },
                        step: 1,
                    },
                }, { // mirror axis on right side
                    opposite: true,
                    categories: [positive],
                    linkedTo: 0,
                    labels: {
                        useHTML:true,
                        style:{
                            fontSize: '11.5px',
                            width:'65px',
                            whiteSpace:'normal',
                        },
                        step: 1,
                    },
                }
            ],
            yAxis: {
                title: {
                    text: null
                },
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                outside: this.context === 'dialog' ? false : true,
                formatter: function () {
                        return this.series.userOptions.customLabel;
                    }
            },
            series: chartData
        }
    }
}